import {systemTypeStringToInt} from "root/Common/Constants/SystemType";

export const doesUserHaveRequiredRole = (testRole, currentUserRoles) =>
{
    if ( Array.isArray( testRole ))
    {
        for (let key in testRole)
        {
            let cur = +testRole[key] ;

            if ( currentUserRoles.includes(cur))
            {
                return true ;
            }
        }

        return false ;
    }
    else
    {
        return currentUserRoles.includes(testRole) ;
    }
}

export const doesUserHaveRequiredRoleForSystem = (testRole, currentUserRoles, system_id) =>
{
    if ( currentUserRoles[system_id] !== undefined )
    {
        const  thisSystemRoleTestRules = currentUserRoles[system_id] ;
        return doesUserHaveRequiredRole(testRole, thisSystemRoleTestRules);
    }
    else
    {
        return false ;
    }
}

export const doesUserHaveRequiredUserTypeForSystem = (testUserType, allowedUserTypes, system_id) =>
{
    if ( allowedUserTypes[system_id] !== undefined )
    {
        return doesUserHaveRequiredUserType (testUserType, allowedUserTypes[system_id])
    }
    else
    {
        return false ;
    }
}

export const doesUserHaveRequiredUserType = (testUserType, allowedUserTypes) =>
{
    return allowedUserTypes.includes(testUserType) ;
}

export const canAuthorityUseThisFeature = (testAuthorityId, authorityObj) =>
{
    if ( authorityObj[testAuthorityId] !== undefined )
    {
        return authorityObj[testAuthorityId] ;
    }
    else
    {
        if ( authorityObj.default !== undefined )
        {
            return authorityObj.default;
        }
        else
        {
            return false ;
        }
    }
}

/**
 * Test function to determine whether the system type specified in the Permissions object allows this
 * functionality.
 *
 * It was introduced at the start of EHCP development to allow PASSPORT features to be switched off for EHCP users
 * so the default is ON if the systems attribute doesn't exist in the object
 *
 * @property string testSystemId    The system ID of the current system ( E.g. EHCP )
 * @property string systemObj       The rule object to be tested
 *
 * @example
 *
 *     canSeeEHCPAdminMenu: {
 *         description: 'User role who can see admin page for EHCP',
 *         name: 'canSeeEHCPAdminMenu',
 *         default: true,
 *         authorities: {
 *             NCC: true,
 *             default: false
 *         },
 *         systems: {
 *             EHCP: true,
 *             PASSPORT: false,
 *             default: false
 *         }
 *     },
 *
 */
export const doesSystemHaveThisFeature = (testSystemId, systemObj) =>
{
    const intValueSystemId = testSystemId ; //  systemTypeStringToInt ( testSystemId );

    if ( systemObj[intValueSystemId] !== undefined )
    {
        return systemObj[intValueSystemId] ;
    }
    else
    {
        if ( systemObj.default !== undefined )
        {
            return systemObj.default;
        }
        else
        {
            return true ;
        }
    }
}